import { useState, useEffect, useCallback, useRef } from 'react';
import { AUDIT_REPORT } from '../../constants/Endpoints';
import auditSheetRepository from '../../repositories/AuditSheetRepository';


const useAuditReport = ({ batchId, chartId, providerId } = {}) => {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);
  // Incrementing this triggers a re-fetch
  const [tick, setTick]       = useState(0);
  const cancelRef             = useRef(false);

  const refresh = useCallback(() => setTick((t) => t + 1), []);

  useEffect(() => {
    if (!batchId && !chartId) return;

    cancelRef.current = false;
    setLoading(true);
    setError(null);

    const run = async () => {
      try {
        const params = {};
        if (batchId)    params.batch_id = batchId;
        if (chartId)    params.chart_id = chartId;
        if (providerId) params.provider_id = providerId;
        const res = await auditSheetRepository.getAuditReport(params);
        if (!cancelRef.current) setData(res);
      } catch (err) {
        if (!cancelRef.current) setError(err.cause.error || 'Failed to load audit report');
      } finally {
        if (!cancelRef.current) setLoading(false);
      }
    };

    run();
    return () => { cancelRef.current = true; };
    // tick is intentionally included so refresh() re-runs this effect
  }, [batchId, chartId, providerId, tick]); // eslint-disable-line react-hooks/exhaustive-deps

  return { data, loading, error, refresh };
};

export default useAuditReport;